import React from "react";
import { Row, Col } from "react-bootstrap";
import { InputBox } from "../../Common";
import Button from "../../Common/Button";
import styles from "./buyStack.module.css";
import {DropDown} from "../../Common";

const StackBuyForm = ({
  formData,
  errors,
  stacks,
  selectedStack,
  handleChange,
  handleDropDownSelect,
  handleSubmit,
  successMessage,
  loading
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <Row style={{ margin: "20px 0", width: "400px" }}>
        <Col md={12} className={styles.inputDiv}>
          <DropDown
            label="Select Stack"
            name="ticker"
            data={stacks.map((stack) => ({
              label: stack.ticker,
              value: stack.ticker,
            }))}
            value={selectedStack}
            onChange={handleDropDownSelect}
            required
            error={!!errors.ticker}
            helperText={errors.ticker}
          />
        </Col>

        <Col md={12} className={styles.inputDiv}>
          <label>
            Amount ($) <span className={styles.required}>*</span>
            <InputBox
              placeholder="Enter Amount"
              type="number"
              name="amount"
              onChange={handleChange}
              value={formData.amount}
            />
            {errors.amount && (
              <span className={styles.error}>{errors.amount}</span>
            )}
          </label>
        </Col>

        <Col md={12} className={styles.inputDiv}>
          <label>
            Comment <span className={styles.required}>*</span>
            <textarea
              placeholder="Enter your comment"
              name="comment"
              onChange={handleChange}
              value={formData.comment}
              rows={8}
              cols={5}
              style={{ width: "100%", fontWeight: "600" }}
            ></textarea>
            {errors.comment && (
              <span className={styles.error}>{errors.comment}</span>
            )}
          </label>
        </Col>
      </Row>

      {successMessage && (
        <div style={{ margin: "20px 0px", textAlign: "center" }}>
          <p style={{ color: "green" }}>{successMessage}</p>
        </div>
      )}

      <Row style={{ margin: "20px 0" }}>
        <Col md={12} className={styles.submitButton}>
          <Button
            onClick={handleSubmit}
            title="Add Stack"
            width="100%"
            disabled={loading}
            loading={loading}
          />
        </Col>
      </Row>
    </form>
  );
};

export default StackBuyForm;
